// I18n Configuration
// Keep at top so that I18n data is initialized early
import I18n from 'I18n';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import 'I18n/init/data/baseLocales';
import { renderWithNavCopilot } from 'quartz-core/client-with-copilot';
import { usageTrackerMiddleware } from 'usage-tracker-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import * as AppActions from '../actions/AppActions';
import { tracker } from 'UserPreferencesUI/lib/tracker';
import Raven from 'raven-js';
import RouteConfig from './RouteConfig';

// React-rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { AppActionTypes } from '../actions/AppActions';
import UIApplication from 'UIComponents/app/UIApplication';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
const dataFetchingClient = new DataFetchingClient();
const routerMiddleware = history => () => next => action => {
  if (action.type === AppActionTypes.HISTORY_METHOD_CALLED) {
    const {
      payload: {
        method,
        args
      }
    } = action;
    history[method](...args);
  }
  return next(action);
};
export default class BaseApplication {
  start() {
    if (window.jasmine) return;
    window.AppInstance = this;
    this.init().catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  init() {
    const authenticate = this.auth();
    authenticate.then(authConfig => {
      this.authConfig = authConfig;
    }).then(() => {
      this.setPageTitle();
      this.startReduxAndRouter();
      this.identifyUser();
    }).catch(error => {
      if (error.message !== 'Aborting: redirection in progress') {
        throw error;
      }
    });
    return authenticate;
  }
  auth() {
    const I18nProvider = createStandardI18nProvider();
    const userHubInfo = this.loadUserHubInfo();
    return userHubInfo.then(({
      portal,
      gates,
      user
    }) => {
      I18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled,
        timezone: portal && portal.timezone
      });
      const langAvailable = Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
      return langAvailable.then(() => {
        I18n.sendSentryOnMissingTranslations = true;
        I18n.sendSentryOnMissingValues = true;
        return {
          portal,
          gates,
          user
        };
      });
    });
  }
  setPageTitle() {
    setDocumentTitle('userPreferences.pageTitle');
  }
  identifyUser() {
    const {
      portal,
      user
    } = this.authConfig;
    const fullName = `${user.first_name} ${user.last_name}`;
    const email = user.email;
    const portalId = portal.portal_id;
    Raven.setUserContext({
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ name: string; email: any; port... Remove this comment to see the full error message
      name: fullName,
      email,
      portalId
    });
  }
  startReduxAndRouter() {
    this.history = createBrowserHistory({
      basename: this.getBaseName()
    });
    const reduxRouterMiddleware = routerMiddleware(this.history);
    const middlewares = [reduxRouterMiddleware, usageTrackerMiddleware(tracker)];
    this.store = configureStore({
      auth: this.authConfig
    }, middlewares);
    this.store.dispatch(AppActions.start());
    const {
      gates
    } = this.authConfig;
    const copilotLayoutType = gates.includes('userSetup:copilotLayouts') ? 'sidebar' : 'panel';
    renderWithNavCopilot( /*#__PURE__*/_jsx(UIApplication, {
      name: "UserPreferencesUI",
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
          client: dataFetchingClient,
          children: /*#__PURE__*/_jsx(RhumbProvider
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'PartialR... Remove this comment to see the full error message
          , {
            config: rhumbConfig,
            history: historyAdapter(this.history),
            children: /*#__PURE__*/_jsx(Router, {
              history: this.history,
              children: /*#__PURE__*/_jsx(RouteConfig, {})
            })
          })
        })
      })
    }), {
      layoutType: copilotLayoutType
    });
  }
}